import Header from "./components/Header";
import Meme from "./components/Meme";
import React from "react";
export default function App(){
    return(
        <div>
          <Header/>
          <Meme/>
        </div>
    )
}